import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enGB from "./en-GB";
import zhHK from "./zh-HK";

const resources = {
  "en-GB": { translation: enGB },
  "zh-HK": { translation: zhHK }
};

let defaultLanguage = localStorage.getItem("system-language");
if(!defaultLanguage || !Object.keys(resources).includes(defaultLanguage)) {
  defaultLanguage = "zh-HK";
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLanguage,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;